'use client';
import { Building2 } from 'lucide-react';
import { Alert, AlertDescription, AlertTitle } from '~/components/ui/alert';
import { Trans } from '~/components/ui/trans';
import type { WorkspaceUsage } from './models';

export function isWorkspaceFull(usage: WorkspaceUsage | null | undefined): usage is WorkspaceUsage {
  return usage != null && usage.property_count >= usage.property_limit;
}

/** Limits stay out of sight until they are reached. Shown wherever a property could otherwise be added to a full workspace. */
export function WorkspaceLimitNotice({ usage }: { usage: WorkspaceUsage }) {
  return (
    <Alert role="status" data-test="workspace-limit-notice">
      <Building2 />
      <AlertTitle>
        <Trans
          i18nKey="parcelWatch.workspace.limitTitle"
          values={{ limit: usage.property_limit }}
        />
      </AlertTitle>
      <AlertDescription>
        <Trans
          i18nKey="parcelWatch.workspace.limitDescription"
          values={{ count: usage.property_count, limit: usage.property_limit }}
        />
      </AlertDescription>
    </Alert>
  );
}
